import React from "react";
import {
  Button,
  Col,
  Dropdown,
  Form,
  Row,
  Modal,
  Card,
  OverlayTrigger,
  Tooltip,
  InputGroup,
} from "react-bootstrap";
import { domainConfig } from "../config.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChalkboard,
  faChalkboardUser,
  faUsersLine,
  faUsers,
  faGamepad, faTrash, faPencil, faLayerGroup,
  faSave, faCheck, faRotateLeft, faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { fillMissingProperties } from '../assets/functions.js'
import { jsonCustomizacao } from "../components/Json.js";
import MemoryGame from '../components/apps/App01.js'
import Quiz from '../components/apps/App02.js'
import QA from '../components/apps/App03.js'
import MessageDisplay from '../components/apps/App04.js'
import WordsBoard from '../components/apps/App05.js'
import PrizeDraw from '../components/apps/App06.js'
import Roullete from '../components/apps/App07.js'
import Photobooth from '../components/apps/App10.js'
import Gallery from '../components/apps/App11.js'
import DrawingBoard from '../components/apps/App12.js'
import DropzoneComponent from "./Dropzone.js";
import Loader from "./Loader.js";

export const AplicativoCard = ({ value, dataHandler }) => (

  <Card className={`mainCard ${value.status === 0 ? 'disabled' : ''}`}>
    <div className={`card-top ${value.status === 0 ? 'bg-danger text-white' : 'bg-primary text-dark'}`}>
      {(() => {
        switch (value.type) {
          case "Aplicativo":
            return (
              <>
                <FontAwesomeIcon icon={faGamepad} className="me-2" size="lg" />
                {value.type}
              </>
            );
          case "Social":
            return (
              <>
                <FontAwesomeIcon icon={faUsers} className="me-2" size="lg" />
                {value.type}
              </>
            );
          default:
            return "";
        }
      })()}
    </div>
    <div
      className={`p-3 aplicativoCard`}
      onClick={() => {
        dataHandler(value);
      }}
    >
      <Card.Img
        className="px-3"
        src={domainConfig.imageServer + "/flex/painel/" + value.imagem}
        alt="aplicativoCard"
      />
      <h5 className="mt-2 mb-1">{value.nome}</h5>
    </div>
  </Card>
);

export const ApplicationsList = ({ aplicativos, setDataAplicativo }) => {

  function dataHandler(value) {
    setDataAplicativo(value);
  }

  return (
    <Row>
      {aplicativos.map((value, index) => {
        if (value.status === 0) {
          return ""
        }
        return (
          <Col key={"card" + index} md="3" sm="6">
            <AplicativoCard value={value} dataHandler={dataHandler} />
          </Col>
        );
      })}
    </Row>
  );
};

export const CustomizationsList = ({
  customizations,
  setDataCustomizacao,
  deleteCustomization,
  onOpenEvent,
  isAdmin,
  customizationScope,
  setCustomizationScope,
}) => {
  const [displayCount, setDisplayCount] = React.useState(12);
  const loaderRef = React.useRef(null);
  const [navSearch, setNavSearch] = React.useState("");
  const [searchQuery, setSearchQuery] = React.useState("");
  const timeoutRef = React.useRef(null);

  const cleanUpSpecialChars = (str) => {
    if (!str) return "";
    return str.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  };

  const executeSearch = React.useCallback((searchTerm) => {
    setSearchQuery(searchTerm);
    setDisplayCount(12);
  }, []);

  const debouncedSearch = React.useCallback((searchTerm) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    timeoutRef.current = setTimeout(() => {
      executeSearch(searchTerm);
    }, 350);
  }, [executeSearch]);

  const handleSearch = React.useCallback((value) => {
    setNavSearch(value);
    debouncedSearch(value);
  }, [debouncedSearch]);

  const handleDataCustomizacao = (value) => {
    let json = jsonCustomizacao(Number(value.aplicativo_id))
    value.json = fillMissingProperties(value.json, json);
    setDataCustomizacao(value)
  }

  React.useEffect(() => {
    const currentLoader = loaderRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting) {
          setTimeout(() => {
            setDisplayCount((prevCount) => prevCount + 12);
          }, 1000);
        }
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    if (currentLoader) {
      observer.observe(currentLoader);
    }

    return () => {
      if (currentLoader) {
        observer.unobserve(currentLoader);
      }
    };
  }, []);

  const filteredCustomizations = React.useMemo(() => {
    if (searchQuery.trim() !== '') {
      const lowercaseQuery = cleanUpSpecialChars(searchQuery);
      return customizations.filter(item => {
        const searchableFields = [
          cleanUpSpecialChars(item.titulo || "")
        ];
        return searchableFields.some(field => field.includes(lowercaseQuery));
      });
    }
    return customizations;
  }, [customizations, searchQuery]);

  const displayedCustomizations = filteredCustomizations.slice(0, displayCount);

  return (
    <>
      <Form inline="true" onSubmit={(event) => event.preventDefault()} className="d-inline-block w-100 mb-3">
        <InputGroup className="input-group-navbar w-100 border rounded bg-white">
          <InputGroup.Text className="bg-transparent border-0 pe-0 text-muted">
            <FontAwesomeIcon icon={faSearch} />
          </InputGroup.Text>
          <Form.Control
            className="border-0 shadow-none bg-transparent"
            type="text"
            value={navSearch}
            placeholder={'Pesquisar customizações...'}
            aria-label="Search"
            onChange={(e) => {
              const value = e.target.value;
              handleSearch(value);
            }}
          />
        </InputGroup>
      </Form>
      {isAdmin && (
        <div className="d-flex justify-content-end mb-3">
          <Dropdown>
            <Dropdown.Toggle className="btn-primary text-nowrap">
              {customizationScope === "all"
                ? "Customizações de todos os usuários"
                : "Minhas customizações"}
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
              <Dropdown.Item
                className={customizationScope === "mine" ? "active" : ""}
                onClick={() => setCustomizationScope("mine")}
              >
                Minhas customizações
              </Dropdown.Item>
              <Dropdown.Item
                className={customizationScope === "all" ? "active" : ""}
                onClick={() => setCustomizationScope("all")}
              >
                Customizações de todos os usuários
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      )}
      <div className="d-flex justify-content-end mb-2">
        <small className="text-muted">
          Mostrando {displayedCustomizations.length} de {filteredCustomizations.length} items
        </small>
      </div>
      <div className="list-group">
        {filteredCustomizations.length > 0 ? (
          <>
            {displayedCustomizations.map((value, index) => {
              const eventLinks = Array.isArray(value.event_links) ? value.event_links : [];
              const eventTitles = Array.isArray(value.event_titles) ? value.event_titles : [];
              const relatedEvents = eventLinks.length > 0
                ? eventLinks
                : eventTitles.map((eventTitle, eventIndex) => ({
                  titulo: eventTitle,
                  eventIndex,
                }));

              return (
                <div
                  key={"gameMode" + index}
                  className="list-group-item list-group-item-action mb-2"
                  aria-current="true"
                >
                  <div className="d-flex w-100 justify-content-between align-items-start gap-3">
                    <h5 className="mb-1 me-2">
                      {value.titulo === "" ? (
                        <span className="text-muted">Sem título</span>
                      ) : (
                        value.titulo
                      )}
                    </h5>
                    <small className="text-nowrap">última edição: {value.data_edicao}</small>
                  </div>
                  <div className="d-flex w-100 justify-content-between gap-3 mt-auto">
                    <div className="d-flex flex-wrap align-items-center gap-2">
                      {value.titulo === "" && (
                        <span className="badge bg-danger text-white">
                          Rascunho
                        </span>
                      )}
                      <span className="badge bg-primary text-white">
                        v.{value.version}
                      </span>
                      {relatedEvents.map((eventData, eventIndex) => {
                        const canOpenEvent = typeof onOpenEvent === "function" && eventData?.evento_id;

                        if (canOpenEvent) {
                          return (
                            <button
                              key={`customization-${value.customizacao_id}-event-${eventData.evento_id}`}
                              type="button"
                              className="badge bg-secondary rounded-pill px-3 py-2 border-0"
                              onClick={(event) => {
                                event.preventDefault();
                                event.stopPropagation();
                                onOpenEvent(eventData);
                              }}
                            >
                              <FontAwesomeIcon icon={faLayerGroup} className="me-1" />
                              {eventData.titulo}
                            </button>
                          );
                        }

                        return (
                          <span
                            key={`customization-${value.customizacao_id}-event-${eventData.eventIndex ?? eventIndex}`}
                            className="badge bg-secondary rounded-pill px-3 py-2"
                          >
                            <FontAwesomeIcon icon={faLayerGroup} className="me-1" />
                            {eventData.titulo}
                          </span>
                        );
                      })}
                    </div>
                    <div className="d-flex gap-2 flex-shrink-0">
                      {deleteCustomization &&
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            deleteCustomization(value["customizacao_id"])
                          }
                        >
                          <FontAwesomeIcon icon={faTrash} size="1x" />
                        </button>}
                      {setDataCustomizacao &&
                        <button
                          type="button"
                          className="btn btn-sm btn-primary"
                          onClick={() => handleDataCustomizacao(value)}
                        >
                          <FontAwesomeIcon icon={faPencil} size="1x" />
                        </button>}
                    </div>
                  </div>
                </div>
              );
            })}
            {displayCount < filteredCustomizations.length && (
              <div ref={loaderRef} className="mt-3">
                <Loader />
              </div>
            )}
          </>
        ) : (
          <h5 className="py-5 text-center opacity-50">
            Nenhuma customização encontrada
          </h5>
        )}
      </div>
    </>
  );
};

export const GameType = ({
  dataAplicativo,
  createCustomization,
  showModalGameType,
  setShowModalGameType,
}) => {
  switch (dataAplicativo.aplicativo_id) {
    case 2:
      return (
        <>
          <Modal
            show={showModalGameType}
            size={"md"}
            onHide={setShowModalGameType}
            centered
            fullscreen={'sm-down'}
            backdrop
          >
            <Modal.Body>
              <Form.Group as={Col}>
                <h4 className="mb-3 mt-2 text-center">Modo de jogo</h4>
              </Form.Group>
              <Form.Group className="mb-3">
                <div className="row mx-0">
                  <div
                    className="gameTypeMode col-md-12 mt-0"
                    onClick={(e) => {
                      createCustomization(1);
                      setShowModalGameType(false);
                    }}
                  >
                    <div className="gameTypeModeIcon">
                      <div className="text-dark bg-light">
                        <FontAwesomeIcon icon={faChalkboard} />
                      </div>
                    </div>
                    <div className="gameTypeModeLabel">
                      <h5 className="mb-0">Individual</h5>
                      <span className="mb-0">
                        Nesse modo é possível responder a qualquer momento
                        durante a duração do evento
                      </span>
                    </div>
                  </div>
                  <div
                    className="gameTypeMode col-md-12"
                    onClick={(e) => {
                      createCustomization(2);
                      setShowModalGameType(false);
                    }}
                  >
                    <div className="gameTypeModeIcon">
                      <div className="text-dark bg-light">
                        <FontAwesomeIcon icon={faUsersLine} />
                      </div>
                    </div>
                    <div className="gameTypeModeLabel">
                      <h5 className="mb-0">Clássico</h5>
                      <span className="mb-0">
                        Os participantes progridem sozinhos e você acompanha os
                        resultados ao vivo
                      </span>
                    </div>
                  </div>
                  <div
                    className="gameTypeMode col-md-12"
                    onClick={(e) => {
                      createCustomization(3);
                      setShowModalGameType(false);
                    }}
                  >
                    <div className="gameTypeModeIcon">
                      <div className="text-dark bg-light">
                        <FontAwesomeIcon icon={faChalkboardUser} />
                      </div>
                    </div>
                    <div className="gameTypeModeLabel">
                      <h5 className="mb-0">Apresentador</h5>
                      <span className="mb-0">
                        Controle o ritmo para que todos avancem em cada pergunta
                        juntos.
                      </span>
                    </div>
                  </div>
                </div>
              </Form.Group>
            </Modal.Body>
          </Modal>
        </>
      );
    default:
      return "";
  }
};

export const AppDefinitions = ({ fonts, aplicativo_id, handleChange, values, setFieldValue, errors, touched, handlePreviewSuccess, handlePreviewError }) => {

  switch (aplicativo_id) {
    case 1:
      return (
        <MemoryGame
          handleChange={handleChange}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
          handlePreviewSuccess={handlePreviewSuccess}
          handlePreviewError={handlePreviewError}
        />
      );
    case 2:
      return (
        <Quiz
          handleChange={handleChange}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
          handlePreviewSuccess={handlePreviewSuccess}
          handlePreviewError={handlePreviewError}
        />
      );
    case 3:
      return (
        <QA
          fonts={fonts}
          handleChange={handleChange}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
          handlePreviewSuccess={handlePreviewSuccess}
          handlePreviewError={handlePreviewError}
        />
      );
    case 4:
      return (
        <MessageDisplay
          fonts={fonts}
          handleChange={handleChange}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
          handlePreviewSuccess={handlePreviewSuccess}
          handlePreviewError={handlePreviewError}
        />
      );
    case 5:
      return (
        <WordsBoard
          fonts={fonts}
          handleChange={handleChange}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
          handlePreviewSuccess={handlePreviewSuccess}
          handlePreviewError={handlePreviewError}
        />
      );
    case 6:
      return (
        <PrizeDraw
          fonts={fonts}
          handleChange={handleChange}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
          handlePreviewSuccess={handlePreviewSuccess}
          handlePreviewError={handlePreviewError}
        />
      )
    case 7:
      return (
        <Roullete
          handleChange={handleChange}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
          handlePreviewSuccess={handlePreviewSuccess}
          handlePreviewError={handlePreviewError}
        />
      )
    case 10:
      return (
        <Photobooth
          handleChange={handleChange}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
          handlePreviewSuccess={handlePreviewSuccess}
          handlePreviewError={handlePreviewError}
        />
      )
    case 11:
      return (
        <Gallery
          fonts={fonts}
          handleChange={handleChange}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
          handlePreviewSuccess={handlePreviewSuccess}
          handlePreviewError={handlePreviewError}
        />
      )
    case 12:
      return (
        <DrawingBoard
          fonts={fonts}
          handleChange={handleChange}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          touched={touched}
          handlePreviewSuccess={handlePreviewSuccess}
          handlePreviewError={handlePreviewError}
        />
      )
    default:
      return <h5>Nenhum componente encontrado</h5>;
  }
}

export const AppSideButtonPanel = ({
  isSubmitting,
  onSubmit,
  onReset,
}) => {
  const handleReset = (e) => {
    e.preventDefault();
    onReset();
  };

  const handleSave = (e) => {
    e.preventDefault();
    onSubmit(false); // false means save and leave
  };

  const handleApply = (e) => {
    e.preventDefault();
    onSubmit(true); // true means apply only (stay on page)
  };

  return (
    <div className="side-panel-button open">
      <OverlayTrigger placement="left" overlay={<Tooltip>Restaurar padrões</Tooltip>}>
        <Button
          type="button"
          variant="primary"
          className="my-1"
          onClick={handleReset}
          disabled={isSubmitting}
        >
          <FontAwesomeIcon icon={faRotateLeft} size={"lg"} />
        </Button>
      </OverlayTrigger>
      <OverlayTrigger placement="left" overlay={<Tooltip>Salvar e continuar</Tooltip>}>
        <Button
          className="my-1"
          variant="primary"
          type="button"
          onClick={handleApply}
          disabled={isSubmitting}
        >
          <FontAwesomeIcon icon={faSave} size={"lg"} />
        </Button>
      </OverlayTrigger>
      <OverlayTrigger placement="left" overlay={<Tooltip>Salvar e finalizar</Tooltip>}>
        <Button
          className="my-1"
          variant="primary"
          type="button"
          onClick={handleSave}
          disabled={isSubmitting}
        >
          <FontAwesomeIcon icon={faCheck} size={"lg"} />
        </Button>
      </OverlayTrigger>
    </div>
  );
};

export const BackgroundFormComponent = ({ touched, errors, values, setFieldValue, handlePreviewSuccess, handlePreviewError }) => {

  switch (values.json.apresentation.textSide.background.type) {
    case 'image':
      return (
        <Form.Group
          as={Col} md={6} className="mb-3">
          <Card className="mb-0">
            <Card.Body>
              <Form.Control
                type="hidden"
                name="json.apresentation.textSide.background.url"
                value={values.json.apresentation.textSide.background.url}
                onChange={(e) => {
                  setFieldValue("json.apresentation.textSide.background.url", e.target.value);
                }}
                isInvalid={!!errors?.json?.apresentation?.textSide?.background?.url}
                isValid={touched?.json?.apresentation?.textSide?.background?.url && !errors?.json?.apresentation?.textSide?.background?.url}
              />
              <div className="imagesUpload">
                <img
                  className={`h-100 img-thumbnail ${!!errors?.json?.apresentation?.textSide?.background?.url ? "is-invalid" : ""}`}
                  src={
                    values.json.apresentation.textSide.background.url !== "" && values.json.apresentation.textSide.background.url !== null
                      ? domainConfig.imageServer +
                      "/customizacao/" +
                      values.customizacao_id +
                      "/" +
                      values.json.apresentation.textSide.background.url
                      : domainConfig.imageServer + "/empty-background.png"
                  }
                  alt="Imagem preview"
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors.json?.apresentation?.textSide?.background?.url}
                </Form.Control.Feedback>
              </div>
              <DropzoneComponent
                className="mt-3 dropzoneComp"
                type="image"
                handlePreviewSuccess={handlePreviewSuccess}
                handlePreviewError={handlePreviewError}
                setFieldValue={setFieldValue}
                folder="customizacao"
                id={values.customizacao_id}
                field="json.apresentation.textSide.background.url"
              />
              <Form.Group className="mt-3">
                <Form.Label>Posição da Imagem</Form.Label>
                <Form.Select
                  name="json.apresentation.textSide.background.backgroundPosition"
                  value={values.json.apresentation.textSide.background.backgroundPosition || "center"}
                  onChange={(e) => {
                    setFieldValue("json.apresentation.textSide.background.backgroundPosition", e.target.value);
                  }}
                  isInvalid={!!errors?.json?.apresentation?.textSide?.background?.backgroundPosition}
                  isValid={touched?.json?.apresentation?.textSide?.background?.backgroundPosition && !errors?.json?.apresentation?.textSide?.background?.backgroundPosition}
                >
                  <option value="top">Topo</option>
                  <option value="center">Centro</option>
                  <option value="bottom">Base</option>
                </Form.Select>
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors.json?.apresentation?.textSide?.background?.backgroundPosition}
                </Form.Control.Feedback>
              </Form.Group>
            </Card.Body>
          </Card>
        </Form.Group>
      )
    case 'video':
      return (
        <Form.Group
          as={Col} md={6} className="mb-3">
          <Card className="mb-0">
            <Card.Body>
              <Form.Control
                type="hidden"
                name="json.apresentation.textSide.background.url"
                value={values.json.apresentation.textSide.background.url}
                onChange={(e) => {
                  setFieldValue("json.apresentation.textSide.background.url", e.target.value);
                }}
                isInvalid={!!errors?.json?.apresentation?.textSide?.background?.url}
                isValid={touched?.json?.apresentation?.textSide?.background?.url && !errors?.json?.apresentation?.textSide?.background?.url}
              />
              <div className="imagesUpload">
                <video
                  className={`h-100 img-thumbnail ${!!errors?.json?.apresentation?.textSide?.background?.url ? "is-invalid" : ""}`}
                  src={
                    values.json.apresentation.textSide.background.url !== "" && values.json.apresentation.textSide.background.url !== null
                      ? domainConfig.imageServer +
                      "/customizacao/" +
                      values.customizacao_id +
                      "/" +
                      values.json.apresentation.textSide.background.url
                      : domainConfig.imageServer + "/empty-background.png"
                  }
                  controls={true}
                />
                <Form.Control.Feedback type="valid"></Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  {errors.json?.apresentation?.textSide?.background?.url}
                </Form.Control.Feedback>
              </div>
              <DropzoneComponent
                className="mt-3 dropzoneComp"
                type="video"
                handlePreviewSuccess={handlePreviewSuccess}
                handlePreviewError={handlePreviewError}
                setFieldValue={setFieldValue}
                folder="customizacao"
                id={values.customizacao_id}
                field="json.apresentation.textSide.background.url"
              />
            </Card.Body>
          </Card>
        </Form.Group>
      )
    default:
      return ("")
  }
}
